import React from 'react'
import {
  ShelfWrapper,
  Title,
  Subtitle,
  ShelfDescription,
  ShelfHeader,
  BtnShelfText,
  BtnShelf,
  EllipsisWrapper
} from './Shelf.styles'
import type { IShelfProps } from './Shelf.types'
import { Button, FontIcon, tokens } from '@arvoreeducacao/bonsai-ds'
import { i18n } from 'i18n'

const Shelf: React.FC<IShelfProps> = ({
  paddingRight,
  isLevelShelf,
  children,
  disableHeader,
  title,
  subtitle,
  titleIcon,
  isSeeAllButtonVisible = true,
  buttonShelf = { text: i18n.t('Ver tudo'), iconName: 'caret-right' },
  onClickBtnGetMore,
  infoButton,
  infoButtonFunction,
  infoButtonText,
  dataTestId
}) => {
  const seeAllText = buttonShelf.text ?? i18n.t('Ver tudo')
  const seeAllLabel = title ? `${seeAllText}: ${title}` : seeAllText

  return (
    <ShelfWrapper
      paddingRight={paddingRight}
      isLevelShelf={isLevelShelf}
      data-testid={dataTestId}
    >
      {!disableHeader && (
        <ShelfHeader>
          <ShelfDescription>
            {titleIcon && (
              <EllipsisWrapper>
                <FontIcon
                  iconName={titleIcon}
                  size={20}
                  color={tokens.colors.dark6}
                />
              </EllipsisWrapper>
            )}
            <Title>{title}</Title>
            <Subtitle>{subtitle}</Subtitle>
          </ShelfDescription>
          {isSeeAllButtonVisible && (
            <BtnShelf
              type="button"
              aria-label={seeAllLabel}
              onClick={onClickBtnGetMore}
            >
              <BtnShelfText>{seeAllText}</BtnShelfText>
              <FontIcon
                iconName={buttonShelf.iconName}
                color={tokens.colors.dark5}
                size={16}
                aria-hidden="true"
              />
            </BtnShelf>
          )}
          {!isSeeAllButtonVisible && infoButton && (
            <Button
              theme={{ type: 'ghost', size: 'medium' }}
              iconName="information"
              isRight
              text={infoButtonText}
              onClick={() => infoButtonFunction()}
            />
          )}
        </ShelfHeader>
      )}
      {children}
    </ShelfWrapper>
  )
}

export default Shelf
